import { render, staticRenderFns } from "./calling-index.vue?vue&type=template&id=e88736c8&scoped=true&"
import script from "./calling-index.vue?vue&type=script&lang=js&"
export * from "./calling-index.vue?vue&type=script&lang=js&"
import style0 from "./calling-index.vue?vue&type=style&index=0&id=e88736c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88736c8",
  null
  
)

export default component.exports